<template>
    <div id="layout">
        <slot />
    </div>
</template>
